import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import i18n, { COUNTRY_LANGUAGE } from '../i18n';
import ISO_TO_COUNTRY_CODE from '../i18n/countryCodeMap.json';

// The real country/theater list this app operates in - matches the mobile
// app's own per-country Home tabs exactly, since a movie only ever belongs
// to one of these (see moviePublicId/theaterNumber on every real movie doc).
export const COUNTRIES = [
  { code: '', label: 'All Countries', flag: '🌐' },
  { code: 'USA', label: 'United States', flag: '🇺🇸' },
  { code: 'UK', label: 'United Kingdom', flag: '🇬🇧' },
  { code: 'INDIA', label: 'India', flag: '🇮🇳' },
  { code: 'AUSTRALIA', label: 'Australia', flag: '🇦🇺' },
  { code: 'CHINA', label: 'China', flag: '🇨🇳' },
  { code: 'GERMANY', label: 'Germany', flag: '🇩🇪' },
  { code: 'JAPAN', label: 'Japan', flag: '🇯🇵' },
  { code: 'KOREA', label: 'South Korea', flag: '🇰🇷' },
  { code: 'MEXICO', label: 'Mexico', flag: '🇲🇽' },
  { code: 'FRANCE', label: 'France', flag: '🇫🇷' },
  { code: 'UKRAINE', label: 'Ukraine', flag: '🇺🇦' },
  { code: 'AFRICA', label: 'Africa', flag: '🌍' },
  { code: 'SPAIN', label: 'Spain', flag: '🇪🇸' },
  { code: 'ITALY', label: 'Italy', flag: '🇮🇹' },
  { code: 'PORTUGAL', label: 'Portugal', flag: '🇵🇹' },
  { code: 'NETHERLANDS', label: 'Netherlands', flag: '🇳🇱' },
  { code: 'BELGIUM', label: 'Belgium', flag: '🇧🇪' },
  { code: 'SWITZERLAND', label: 'Switzerland', flag: '🇨🇭' },
  { code: 'AUSTRIA', label: 'Austria', flag: '🇦🇹' },
  { code: 'SWEDEN', label: 'Sweden', flag: '🇸🇪' },
  { code: 'NORWAY', label: 'Norway', flag: '🇳🇴' },
  { code: 'DENMARK', label: 'Denmark', flag: '🇩🇰' },
  { code: 'FINLAND', label: 'Finland', flag: '🇫🇮' },
  { code: 'POLAND', label: 'Poland', flag: '🇵🇱' },
  { code: 'CZECHIA', label: 'Czechia', flag: '🇨🇿' },
  { code: 'SLOVAKIA', label: 'Slovakia', flag: '🇸🇰' },
  { code: 'HUNGARY', label: 'Hungary', flag: '🇭🇺' },
  { code: 'ROMANIA', label: 'Romania', flag: '🇷🇴' },
  { code: 'BULGARIA', label: 'Bulgaria', flag: '🇧🇬' },
  { code: 'GREECE', label: 'Greece', flag: '🇬🇷' },
  { code: 'CROATIA', label: 'Croatia', flag: '🇭🇷' },
  { code: 'SERBIA', label: 'Serbia', flag: '🇷🇸' },
  { code: 'SLOVENIA', label: 'Slovenia', flag: '🇸🇮' },
  { code: 'BOSNIA', label: 'Bosnia', flag: '🇧🇦' },
  { code: 'ALBANIA', label: 'Albania', flag: '🇦🇱' },
  { code: 'MACEDONIA', label: 'Macedonia', flag: '🇲🇰' },
  { code: 'MONTENEGRO', label: 'Montenegro', flag: '🇲🇪' },
  { code: 'KOSOVO', label: 'Kosovo', flag: '🇽🇰' },
  { code: 'IRELAND', label: 'Ireland', flag: '🇮🇪' },
  { code: 'ICELAND', label: 'Iceland', flag: '🇮🇸' },
  { code: 'ESTONIA', label: 'Estonia', flag: '🇪🇪' },
  { code: 'LATVIA', label: 'Latvia', flag: '🇱🇻' },
  { code: 'LITHUANIA', label: 'Lithuania', flag: '🇱🇹' },
  { code: 'LUXEMBOURG', label: 'Luxembourg', flag: '🇱🇺' },
  { code: 'MALTA', label: 'Malta', flag: '🇲🇹' },
  { code: 'CYPRUS', label: 'Cyprus', flag: '🇨🇾' },
  { code: 'MOLDOVA', label: 'Moldova', flag: '🇲🇩' },
  { code: 'BELARUS', label: 'Belarus', flag: '🇧🇾' },
  { code: 'GEORGIA', label: 'Georgia', flag: '🇬🇪' },
  { code: 'ARMENIA', label: 'Armenia', flag: '🇦🇲' },
  { code: 'AZERBAIJAN', label: 'Azerbaijan', flag: '🇦🇿' },
  { code: 'ANDORRA', label: 'Andorra', flag: '🇦🇩' },
  { code: 'MONACO', label: 'Monaco', flag: '🇲🇨' },
  { code: 'SANMARINO', label: 'Sanmarino', flag: '🇸🇲' },
  { code: 'LIECHTENSTEIN', label: 'Liechtenstein', flag: '🇱🇮' },
  { code: 'VATICAN', label: 'Vatican', flag: '🇻🇦' },
  { code: 'RUSSIA', label: 'Russia', flag: '🇷🇺' },
  { code: 'INDONESIA', label: 'Indonesia', flag: '🇮🇩' },
  { code: 'PAKISTAN', label: 'Pakistan', flag: '🇵🇰' },
  { code: 'BANGLADESH', label: 'Bangladesh', flag: '🇧🇩' },
  { code: 'PHILIPPINES', label: 'Philippines', flag: '🇵🇭' },
  { code: 'VIETNAM', label: 'Vietnam', flag: '🇻🇳' },
  { code: 'THAILAND', label: 'Thailand', flag: '🇹🇭' },
  { code: 'MYANMAR', label: 'Myanmar', flag: '🇲🇲' },
  { code: 'MALAYSIA', label: 'Malaysia', flag: '🇲🇾' },
  { code: 'NEPAL', label: 'Nepal', flag: '🇳🇵' },
  { code: 'SRILANKA', label: 'Srilanka', flag: '🇱🇰' },
  { code: 'CAMBODIA', label: 'Cambodia', flag: '🇰🇭' },
  { code: 'LAOS', label: 'Laos', flag: '🇱🇦' },
  { code: 'MONGOLIA', label: 'Mongolia', flag: '🇲🇳' },
  { code: 'BHUTAN', label: 'Bhutan', flag: '🇧🇹' },
  { code: 'SINGAPORE', label: 'Singapore', flag: '🇸🇬' },
  { code: 'BRUNEI', label: 'Brunei', flag: '🇧🇳' },
  { code: 'TIMORLESTE', label: 'Timorleste', flag: '🇹🇱' },
  { code: 'MALDIVES', label: 'Maldives', flag: '🇲🇻' },
  { code: 'KAZAKHSTAN', label: 'Kazakhstan', flag: '🇰🇿' },
  { code: 'UZBEKISTAN', label: 'Uzbekistan', flag: '🇺🇿' },
  { code: 'TURKMENISTAN', label: 'Turkmenistan', flag: '🇹🇲' },
  { code: 'TAJIKISTAN', label: 'Tajikistan', flag: '🇹🇯' },
  { code: 'KYRGYZSTAN', label: 'Kyrgyzstan', flag: '🇰🇬' },
  { code: 'AFGHANISTAN', label: 'Afghanistan', flag: '🇦🇫' },
  { code: 'IRAN', label: 'Iran', flag: '🇮🇷' },
  { code: 'IRAQ', label: 'Iraq', flag: '🇮🇶' },
  { code: 'SAUDIARABIA', label: 'Saudiarabia', flag: '🇸🇦' },
  { code: 'UAE', label: 'Uae', flag: '🇦🇪' },
  { code: 'QATAR', label: 'Qatar', flag: '🇶🇦' },
  { code: 'KUWAIT', label: 'Kuwait', flag: '🇰🇼' },
  { code: 'BAHRAIN', label: 'Bahrain', flag: '🇧🇭' },
  { code: 'OMAN', label: 'Oman', flag: '🇴🇲' },
  { code: 'JORDAN', label: 'Jordan', flag: '🇯🇴' },
  { code: 'LEBANON', label: 'Lebanon', flag: '🇱🇧' },
  { code: 'ISRAEL', label: 'Israel', flag: '🇮🇱' },
  { code: 'PALESTINE', label: 'Palestine', flag: '🇵🇸' },
  { code: 'SYRIA', label: 'Syria', flag: '🇸🇾' },
  { code: 'YEMEN', label: 'Yemen', flag: '🇾🇪' },
  { code: 'TURKEY', label: 'Turkey', flag: '🇹🇷' },
  { code: 'TAIWAN', label: 'Taiwan', flag: '🇹🇼' },
  { code: 'HONGKONG', label: 'Hongkong', flag: '🇭🇰' },
  { code: 'MACAU', label: 'Macau', flag: '🇲🇴' },
  { code: 'NIGERIA', label: 'Nigeria', flag: '🇳🇬' },
  { code: 'EGYPT', label: 'Egypt', flag: '🇪🇬' },
  { code: 'SOUTHAFRICA', label: 'Southafrica', flag: '🇿🇦' },
  { code: 'KENYA', label: 'Kenya', flag: '🇰🇪' },
  { code: 'ETHIOPIA', label: 'Ethiopia', flag: '🇪🇹' },
  { code: 'GHANA', label: 'Ghana', flag: '🇬🇭' },
  { code: 'TANZANIA', label: 'Tanzania', flag: '🇹🇿' },
  { code: 'UGANDA', label: 'Uganda', flag: '🇺🇬' },
  { code: 'ALGERIA', label: 'Algeria', flag: '🇩🇿' },
  { code: 'MOROCCO', label: 'Morocco', flag: '🇲🇦' },
  { code: 'TUNISIA', label: 'Tunisia', flag: '🇹🇳' },
  { code: 'LIBYA', label: 'Libya', flag: '🇱🇾' },
  { code: 'SUDAN', label: 'Sudan', flag: '🇸🇩' },
  { code: 'SENEGAL', label: 'Senegal', flag: '🇸🇳' },
  { code: 'IVORYCOAST', label: 'Ivorycoast', flag: '🇨🇮' },
  { code: 'CAMEROON', label: 'Cameroon', flag: '🇨🇲' },
  { code: 'MALI', label: 'Mali', flag: '🇲🇱' },
  { code: 'BURKINAFASO', label: 'Burkinafaso', flag: '🇧🇫' },
  { code: 'NIGER', label: 'Niger', flag: '🇳🇪' },
  { code: 'CHAD', label: 'Chad', flag: '🇹🇩' },
  { code: 'GUINEA', label: 'Guinea', flag: '🇬🇳' },
  { code: 'BENIN', label: 'Benin', flag: '🇧🇯' },
  { code: 'TOGO', label: 'Togo', flag: '🇹🇬' },
  { code: 'RWANDA', label: 'Rwanda', flag: '🇷🇼' },
  { code: 'BURUNDI', label: 'Burundi', flag: '🇧🇮' },
  { code: 'SOMALIA', label: 'Somalia', flag: '🇸🇴' },
  { code: 'ZAMBIA', label: 'Zambia', flag: '🇿🇲' },
  { code: 'ZIMBABWE', label: 'Zimbabwe', flag: '🇿🇼' },
  { code: 'MOZAMBIQUE', label: 'Mozambique', flag: '🇲🇿' },
  { code: 'ANGOLA', label: 'Angola', flag: '🇦🇴' },
  { code: 'NAMIBIA', label: 'Namibia', flag: '🇳🇦' },
  { code: 'BOTSWANA', label: 'Botswana', flag: '🇧🇼' },
  { code: 'MALAWI', label: 'Malawi', flag: '🇲🇼' },
  { code: 'MADAGASCAR', label: 'Madagascar', flag: '🇲🇬' },
  { code: 'CONGODR', label: 'Congodr', flag: '🇨🇩' },
  { code: 'CONGO', label: 'Congo', flag: '🇨🇬' },
  { code: 'GABON', label: 'Gabon', flag: '🇬🇦' },
  { code: 'SIERRALEONE', label: 'Sierraleone', flag: '🇸🇱' },
  { code: 'LIBERIA', label: 'Liberia', flag: '🇱🇷' },
  { code: 'GAMBIA', label: 'Gambia', flag: '🇬🇲' },
  { code: 'ERITREA', label: 'Eritrea', flag: '🇪🇷' },
  { code: 'DJIBOUTI', label: 'Djibouti', flag: '🇩🇯' },
  { code: 'SOUTHSUDAN', label: 'Southsudan', flag: '🇸🇸' },
  { code: 'EQUATORIALGUINEA', label: 'Equatorialguinea', flag: '🇬🇶' },
  { code: 'MAURITANIA', label: 'Mauritania', flag: '🇲🇷' },
  { code: 'LESOTHO', label: 'Lesotho', flag: '🇱🇸' },
  { code: 'ESWATINI', label: 'Eswatini', flag: '🇸🇿' },
  { code: 'COMOROS', label: 'Comoros', flag: '🇰🇲' },
  { code: 'CAPEVERDE', label: 'Capeverde', flag: '🇨🇻' },
  { code: 'MAURITIUS', label: 'Mauritius', flag: '🇲🇺' },
  { code: 'SEYCHELLES', label: 'Seychelles', flag: '🇸🇨' },
  { code: 'GUINEABISSAU', label: 'Guineabissau', flag: '🇬🇼' },
  { code: 'CENTRALAFRICANREPUBLIC', label: 'Centralafricanrepublic', flag: '🇨🇫' },
  { code: 'SAOTOME', label: 'Saotome', flag: '🇸🇹' },
  { code: 'CANADA', label: 'Canada', flag: '🇨🇦' },
  { code: 'GUATEMALA', label: 'Guatemala', flag: '🇬🇹' },
  { code: 'CUBA', label: 'Cuba', flag: '🇨🇺' },
  { code: 'HAITI', label: 'Haiti', flag: '🇭🇹' },
  { code: 'DOMINICANREPUBLIC', label: 'Dominicanrepublic', flag: '🇩🇴' },
  { code: 'HONDURAS', label: 'Honduras', flag: '🇭🇳' },
  { code: 'ELSALVADOR', label: 'Elsalvador', flag: '🇸🇻' },
  { code: 'NICARAGUA', label: 'Nicaragua', flag: '🇳🇮' },
  { code: 'COSTARICA', label: 'Costarica', flag: '🇨🇷' },
  { code: 'PANAMA', label: 'Panama', flag: '🇵🇦' },
  { code: 'JAMAICA', label: 'Jamaica', flag: '🇯🇲' },
  { code: 'TRINIDAD', label: 'Trinidad', flag: '🇹🇹' },
  { code: 'BAHAMAS', label: 'Bahamas', flag: '🇧🇸' },
  { code: 'BARBADOS', label: 'Barbados', flag: '🇧🇧' },
  { code: 'BELIZE', label: 'Belize', flag: '🇧🇿' },
  { code: 'ANTIGUA', label: 'Antigua', flag: '🇦🇬' },
  { code: 'SAINTLUCIA', label: 'Saintlucia', flag: '🇱🇨' },
  { code: 'SAINTVINCENT', label: 'Saintvincent', flag: '🇻🇨' },
  { code: 'GRENADA', label: 'Grenada', flag: '🇬🇩' },
  { code: 'SAINTKITTS', label: 'Saintkitts', flag: '🇰🇳' },
  { code: 'DOMINICA', label: 'Dominica', flag: '🇩🇲' },
  { code: 'BRAZIL', label: 'Brazil', flag: '🇧🇷' },
  { code: 'ARGENTINA', label: 'Argentina', flag: '🇦🇷' },
  { code: 'COLOMBIA', label: 'Colombia', flag: '🇨🇴' },
  { code: 'PERU', label: 'Peru', flag: '🇵🇪' },
  { code: 'VENEZUELA', label: 'Venezuela', flag: '🇻🇪' },
  { code: 'CHILE', label: 'Chile', flag: '🇨🇱' },
  { code: 'ECUADOR', label: 'Ecuador', flag: '🇪🇨' },
  { code: 'BOLIVIA', label: 'Bolivia', flag: '🇧🇴' },
  { code: 'PARAGUAY', label: 'Paraguay', flag: '🇵🇾' },
  { code: 'URUGUAY', label: 'Uruguay', flag: '🇺🇾' },
  { code: 'GUYANA', label: 'Guyana', flag: '🇬🇾' },
  { code: 'SURINAME', label: 'Suriname', flag: '🇸🇷' },
  { code: 'NEWZEALAND', label: 'Newzealand', flag: '🇳🇿' },
  { code: 'FIJI', label: 'Fiji', flag: '🇫🇯' },
  { code: 'PAPUANEWGUINEA', label: 'Papuanewguinea', flag: '🇵🇬' },
  { code: 'SOLOMONISLANDS', label: 'Solomonislands', flag: '🇸🇧' },
  { code: 'VANUATU', label: 'Vanuatu', flag: '🇻🇺' },
  { code: 'SAMOA', label: 'Samoa', flag: '🇼🇸' },
  { code: 'TONGA', label: 'Tonga', flag: '🇹🇴' },
  { code: 'KIRIBATI', label: 'Kiribati', flag: '🇰🇮' },
  { code: 'MICRONESIA', label: 'Micronesia', flag: '🇫🇲' },
  { code: 'PALAU', label: 'Palau', flag: '🇵🇼' },
  { code: 'MARSHALLISLANDS', label: 'Marshallislands', flag: '🇲🇭' },
  { code: 'NAURU', label: 'Nauru', flag: '🇳🇷' },
  { code: 'TUVALU', label: 'Tuvalu', flag: '🇹🇻' },
];

const STORAGE_KEY = 'starview_web_country';
const CountryContext = createContext(null);

// Same IP geolocation service and response shape as the mobile app's
// detectCountryCode() (app/utils/countryTabs.js) - ipapi.co needs no API
// key and is directly fetchable from the browser.
async function detectCountryCode() {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 5000);
  try {
    const response = await fetch('https://ipapi.co/json/', { signal: controller.signal });
    if (!response.ok) throw new Error(`IP lookup failed with status ${response.status}`);
    const data = await response.json();
    return data.country_code || null;
  } catch (error) {
    console.warn('[CountryContext] IP geolocation failed:', error.message);
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
}

export function CountryProvider({ children }) {
  const [country, setCountry] = useState(() => localStorage.getItem(STORAGE_KEY) || 'USA');
  const hasStoredPreference = useRef(!!localStorage.getItem(STORAGE_KEY));

  // Runs once, only for a genuinely first-time visitor (no stored country
  // yet, from either a manual pick or a prior detection) - real IP-based
  // language/country detection, same as the mobile app already does at
  // signup. A visitor can always override it via CountrySelector afterward;
  // that manual choice is what STORAGE_KEY then holds, so this never runs
  // again and never overwrites it.
  useEffect(() => {
    if (hasStoredPreference.current) return;
    let cancelled = false;
    detectCountryCode().then((isoCode) => {
      if (cancelled || !isoCode) return;
      const detected = ISO_TO_COUNTRY_CODE[isoCode.toUpperCase()];
      if (detected) setCountry(detected);
    });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, country);
    // Language follows the selected country/theater - e.g. picking France
    // switches the whole site to French, one control instead of two.
    i18n.changeLanguage(COUNTRY_LANGUAGE[country] || 'en');
  }, [country]);

  return (
    <CountryContext.Provider value={{ country, setCountry, countries: COUNTRIES }}>
      {children}
    </CountryContext.Provider>
  );
}

export function useCountry() {
  const ctx = useContext(CountryContext);
  if (!ctx) throw new Error('useCountry must be used within CountryProvider');
  return ctx;
}
